export const ACCREDITATION_1000_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "Accreditation logo",
    meta_title: "NAAC A+",
    meta_sub_title: "Accredited with {A+ Grade}",
    meta_priority: 1,
    meta_status: true,
  },

  ACCREDITATION_1000_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Section title (use {…} for bold)",
      value: "Global {Recognition}",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Global {Recognition}",
      required: true,
      defaultValue: "Global {Recognition}",
    },
    {
      fieldName: "background_image_desktop",
      label: "Background image — desktop",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop background",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_image_mobile",
      label: "Background image — mobile",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile background",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Accreditation (carousel) status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Logo",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo",
    },
    {
      header: "Logo alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
    },
    {
      header: "Card title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. NAAC A+",
    },
    {
      header: "Description (use {…} for bold)",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "e.g. Accredited with {A+ Grade}",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable item",
      defaultValue: true,
    },
  ],
};
